import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const fiscalPaymentsConstants = {
  GET_PRECOG_FISCAL_PAYMENTS_START: "GET_PRECOG_FISCAL_PAYMENTS_START",
  GET_PRECOG_FISCAL_PAYMENTS_SUCCESS: "GET_PRECOG_FISCAL_PAYMENTS_SUCCESS",
  GET_PRECOG_FISCAL_PAYMENTS_ERROR: "GET_PRECOG_FISCAL_PAYMENTS_ERROR",
  UPDATE_PRECOG_FISCAL_PAYMENTS_START: "UPDATE_PRECOG_FISCAL_PAYMENTS_START",
  UPDATE_PRECOG_FISCAL_PAYMENTS_SUCCESS: "UPDATE_PRECOG_FISCAL_PAYMENTS_SUCCESS",
  UPDATE_PRECOG_FISCAL_PAYMENTS_ERROR: "UPDATE_PRECOG_FISCAL_PAYMENTS_ERROR",
  CREATE_PRECOG_FISCAL_PAYMENTS_START: "CREATE_PRECOG_FISCAL_PAYMENTS_START",
  CREATE_PRECOG_FISCAL_PAYMENTS_SUCCESS: "CREATE_PRECOG_FISCAL_PAYMENTS_SUCCESS",
  CREATE_PRECOG_FISCAL_PAYMENTS_ERROR: "CREATE_PRECOG_FISCAL_PAYMENTS_ERROR",
  CLEAR_PRECOG_FISCAL_PAYMENTS: "CLEAR_PRECOG_FISCAL_PAYMENTS"
};
/**
 *
 * @returns lista degli acconti da tenere in tabella
 */
export function getFiscalPaymentAdvance() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;
    const factType = getState().precog?.invoiceDetail?.data?.factType;
    const active = getState().precog?.invoiceDetail?.data?.doc?.active;

    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/fiscal-payment?managerId=${managerId}&itemId=${itemId}&factType=${factType}&active=${active}`,
        headers: {
          ...createHttpHeaderWithAuthorization(
            auth.loginAuth.securityToken, null, managerCF, itemCF
          )
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            resolve(result.data);
          } else {
            reject();
          }
        })
        .catch((response) => {
          reject();
        });
    });
  };
}

/**
 * Crea il pagamento/incasso dalla compilazione della form
 * @returns
 */
export function createFiscalPayment(draftId, rowFiscalPayments) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;
    // faccio la chiamata solo quando ho tutti i dati

    dispatch({
      type: fiscalPaymentsConstants.CREATE_PRECOG_FISCAL_PAYMENTS_START
    });

    return new Promise((resolve, reject) => {
      if (rowFiscalPayments?.registeredPaymentId || (!rowFiscalPayments?.registeredPaymentId && rowFiscalPayments.conto && rowFiscalPayments.total)) {
        
        let request = {
          method: "POST",
          url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/fiscalPayments?managerId=${managerId}&itemId=${itemId}`,
          headers: {
            ...createHttpHeaderWithAuthorization(
              auth.loginAuth.securityToken, null, managerCF, itemCF
            )
          },
          data: {
            account: rowFiscalPayments.conto,
            amount: rowFiscalPayments.total,
            registeredPaymentId: rowFiscalPayments?.registeredPaymentId,
            type: "PAYMENT" // TODO capire quale type andrà
          }
        };
        callWithRetry(
          auth, request, dispatch
        )
          .then(async(result) => {
            if (result.status === 200 || result.status === 202) {
              dispatch({
                type: fiscalPaymentsConstants.CREATE_PRECOG_FISCAL_PAYMENTS_SUCCESS
              });
              resolve(result.data);
            } else {
              dispatch({
                type: fiscalPaymentsConstants.CREATE_PRECOG_FISCAL_PAYMENTS_ERROR
              });
              reject();
            }
          })
          .catch((response) => {
            dispatch({
              type: fiscalPaymentsConstants.CREATE_PRECOG_FISCAL_PAYMENTS_ERROR
            });
            reject();
          });
      } else {
        dispatch({
          type: fiscalPaymentsConstants.CREATE_PRECOG_FISCAL_PAYMENTS_ERROR
        });
        reject();
      }
    });
  };
}

/**
 * Aggiorna il pagamento/incasso dalla compilazione della form
 * @returns
 */
export function updateFiscalPayment(draftId, rowFiscalPayments) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;

    // faccio la chiamata solo quando ho tutti i dati
    if (rowFiscalPayments?.registeredPaymentId || (!rowFiscalPayments?.registeredPaymentId && rowFiscalPayments.conto && rowFiscalPayments.total)) {
      dispatch({
        type: fiscalPaymentsConstants.UPDATE_PRECOG_FISCAL_PAYMENTS_START
      });
      new Promise((resolve, reject) => {
        let request = {
          method: "PATCH",
          url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/fiscalPayments/${rowFiscalPayments.uuid}?managerId=${managerId}&itemId=${itemId}`,
          headers: {
            ...createHttpHeaderWithAuthorization(
              auth.loginAuth.securityToken, null, managerCF, itemCF
            )
          },
          data: {
            account: rowFiscalPayments?.conto,
            amount: rowFiscalPayments?.total,
            registeredPaymentId: rowFiscalPayments?.registeredPaymentId,
            type: rowFiscalPayments?.type
          }
        };
        
        callWithRetry(
          auth, request, dispatch
        )
          .then(async(result) => {
            if (result.status === 200 || result.status === 202) {
              dispatch({
                type: fiscalPaymentsConstants.UPDATE_PRECOG_FISCAL_PAYMENTS_SUCCESS
              });
              resolve(result.data);
            } else {
              dispatch({
                type: fiscalPaymentsConstants.UPDATE_PRECOG_FISCAL_PAYMENTS_ERROR
              });
              reject();
            }
          })
          .catch((response) => {
            dispatch({
              type: fiscalPaymentsConstants.UPDATE_PRECOG_FISCAL_PAYMENTS_ERROR
            });
            reject();
          });
      });
    }
  };
}

/**
 * Cancella un inserimento utente su incasso/pagamento
 * @returns
 */
export function deleteFiscalPayment(draftId, uuidToRemove) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "DELETE",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/fiscalPayments/${uuidToRemove}?managerId=${managerId}&itemId=${itemId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(
            auth.loginAuth.securityToken, null, managerCF, itemCF
          )
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            resolve(result.data);
          } else {
            reject();
          }
        })
        .catch((response) => {
          reject();
        });
    });
  };
}

export function clearPrecogFiscalPayment() {
  return (dispatch, getState) => {
    dispatch({
      type: fiscalPaymentsConstants.CLEAR_PRECOG_FISCAL_PAYMENTS
    });
  };
}
/**
 * Restituisce sia le righe che gli id selezionati tra gli acconti salvati in precedenza
 * @returns
 */
export function getPrecogFiscalPayment(draftId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    const managerCF = getState().main.accountantSelected;
    const itemCF = getState().main.companySelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: fiscalPaymentsConstants.GET_PRECOG_FISCAL_PAYMENTS_START
      });

      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/fiscalPayments?managerId=${managerId}&itemId=${itemId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(
            auth.loginAuth.securityToken, null, managerCF, itemCF
          )
        }
      };
      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: fiscalPaymentsConstants.GET_PRECOG_FISCAL_PAYMENTS_SUCCESS,
              payload: result.data
              /* payload: [
                {"uuid":"9b9600d3-6689-4dec-9421-cb461e85c331","account":"11/25/005","amount":100.5},
                {"uuid":"b08b6ebf-a6d8-4a08-98e6-8513ba527a9a","account":"28/45/200","amount":10.5}
              ]*/
            });
            resolve(result.data);
          } else {
            dispatch({
              type: fiscalPaymentsConstants.GET_PRECOG_FISCAL_PAYMENTS_ERROR
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: fiscalPaymentsConstants.GET_PRECOG_FISCAL_PAYMENTS_ERROR
          });
          reject();
        });
    });
  };
}
